const utils = require("./utils");

/**
 * BaiduPolylineOptions
 * @typedef {Object} BaiduPolylineOptions
 * @property {BMap.Map} [map] Map on which to display Polyline.
 * @property {Array<BMap.Point>} [path] The ordered sequence of coordinates of the Polyline
 * @property {string} strokeColor
 * @property {number|string} strokeOpacity
 * @property {number} strokeWeight
 * @property {string} strokeStyle
 */

/**
 * Gets route abstraction.
 * @private
 * @param {BaiduPolylineOptions|google.maps.PolylineOptions} options options
 * @returns {BaiduPolyline|google.maps.Polyline}
 */
function getPolyline(options) {
    return new google.maps.Polyline(options);
}

module.exports = getPolyline;
